import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={videos.concacaf_gold_cup.videoUrl}
    title="Watch the CONCACAF Gold Cup"
    subtitle="With every game live on FOX, FS1 & FS2"
    networkSet="soccer"
    //REMOVED: univision_removed
    // customNetworks={['fox', 'fs1', 'fs2', 'tudn']}
    //REPLACED: univision_removed
    customNetworks={['fox', 'fs1', 'fs2']}
    sportId={sportIds.Soccer}
    leagueId={leagueIds['CONCACAF Nations League']}
    caRedirectUrl="/ca/concacaf-gold-cup/"
  />
)
